import { mapState } from "vuex";

export default {
  methods: {
    // Optional clientId parameter
    // Uses the user's clientId if not provided
    isApprovalQueueEnabled(clientId = undefined) {
      if (clientId) {
        const client = (this.clients || []).find((c) => c.clientId === clientId);
        if (client) return client.onboardingApprovalQueueEnabled;
      }
      return this.userProfile.Client.onboardingApprovalQueueEnabled;
    },
  },
  computed: {
    ...mapState(["featureFlags", "userProfile", "clients"]),
  },
};
